module.exports = __webpack_public_path__ + "img/ledger-city.73cf8fb9.png";